import { Period } from '@/app/models/period';
import { createContext, Dispatch, SetStateAction, useContext, useMemo, useState } from 'react';

type PeriodContextType = {
  selectedPeriod: Period | undefined;
  setSelectedPeriod: Dispatch<SetStateAction<Period | undefined>>;
};

const PeriodContext = createContext<PeriodContextType | undefined>(undefined);

export function PeriodProvider({ children }: { children: React.ReactNode }) {
  const [selectedPeriod, setSelectedPeriod] = useState<Period | undefined>(undefined);

  const contextValue = useMemo(() => ({ selectedPeriod, setSelectedPeriod }), [selectedPeriod]);

  return <PeriodContext.Provider value={contextValue}>{children}</PeriodContext.Provider>;
}

export const usePeriod = () => {
  const context = useContext(PeriodContext);
  if (!context) {
    throw new Error('usePeriod must be used within a PeriodProvider');
  }
  return context;
};
